import React, { useRef, useEffect, useState } from "react";
import { MdCreditScore } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";

import {
  tenant,
  updateTenant,
  fetchTenants,
  deleteTenant,
} from "../../../../redux/slices/sliceActions";

const TenantModificationModal = ({
  setShowPay,
  fieldToShow,
  tenantData,
  setTenantData,
}) => {
  //data fetched from the store
  const dispatch = useDispatch();

  const { property, user } = useSelector((state) => state.landlordslice);
  const token = user?.accessToken;
  const id = user?.user?.user_id;
  const property_id = user?.user?.propertyId;

  const [houseNumbers, setHouseNumbers] = useState([]);
  const [vacantHouses, setVacantHouses] = useState([]);
  const [occupiedHouses, setOccupiedHouses] = useState([]);
  const [houseList, setHouseList] = useState([]);
  useEffect(() => {
    console.log("here is the property", property);
    setHouseNumbers(
      property?.houses
        ?.filter((item) => item.house_number) // Filter only objects with 'house_number'
        .map((item) => item.house_number)
    );
    setVacantHouses(
      property?.houses
        ?.filter(
          (item) => item.tenancy_status !== "occupied" && item.house_number
        ) // Filter out vacant houses with a house number
        .map((item) => item.house_number) // Extract house number
    );

    setOccupiedHouses(
      property?.houses
        ?.filter(
          (item) => item.tenancy_status === "occupied" && item.house_number
        ) // Filter out occupied houses with a house number
        .map((item) => item.house_number) // Extract house number
    );

    //set the all house objects except the ones without house number
    setHouseList(property?.houses?.filter((item) => item.house_number));
  }, [property]);
  const modalRef = useRef();
  const [isClosing, setIsClosing] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [selectedHouseNumber, setSelectedHouseNumber] = useState("");

  // Tenant state for the form
  const [tenantInfo, setTenantInfo] = useState({
    firstName: tenantData.firstName,
    lastName: tenantData.lastName,
    email: tenantData.email,
    phoneNumber: tenantData.phoneNumber,
    emergencyContact: tenantData.emergency_contact_phone,
    nationalId: tenantData.nationalID,
  });

  // Check if the screen is small
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768); // Small and medium screens
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Handle closing the modal
  const closeModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setShowPay(false);
      setTenantData({});
    }, 300); // Slight delay for close animation
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTenantInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }));
  };

  // House selection for edit tenant unspecified
  const handleHouseSelection = (e) => {
    setSelectedHouseNumber(e.target.value);

    //pick the house object that fits the selected house number
    const selectedHouse = houseList.find(
      (house) => house.house_number === e.target.value
    );
    console.log("houses", selectedHouse);

    setTenantInfo({
      id: selectedHouse?.tenant?.tenant_id || "N/A",
      name: selectedHouse?.tenant?.tenant_name || "N/A",
      dateJoined: selectedHouse?.tenant?.created_at || "N/A",
      apartmentNumber: selectedHouse?.house_number || "N/A",
      email: selectedHouse?.tenant?.tenant_email || "N/A",
      phoneNumber: selectedHouse?.tenant?.tenant_phone_number || "N/A",
      houseType: selectedHouse?.house_type || "N/A",
      nationalID: selectedHouse?.tenant?.national_id || "N/A",
      firstName: selectedHouse?.tenant?.tenant_name.split(" ")[0] || "N/A",
      lastName: selectedHouse?.tenant?.tenant_name.split(" ")[1] || "N/A",
      emergencyContact: selectedHouse?.tenant?.emergency_contact_phone || "N/A",
    });
    setTenantData({
      id: selectedHouse?.tenant?.tenant_id || "N/A",
      name: selectedHouse?.tenant?.tenant_name || "N/A",
      dateJoined: selectedHouse?.tenant?.created_at || "N/A",
      apartmentNumber: selectedHouse?.house_number || "N/A",
      email: selectedHouse?.tenant?.tenant_email || "N/A",
      phoneNumber: selectedHouse?.tenant?.tenant_phone_number || "N/A",
      houseType: selectedHouse?.house_type || "N/A",
      nationalID: selectedHouse?.tenant?.national_id || "N/A",
      firstName: selectedHouse?.tenant?.tenant_name.split(" ")[0] || "N/A",
      lastName: selectedHouse?.tenant?.tenant_name.split(" ")[1] || "N/A",
      emergencyContact: selectedHouse?.tenant?.emergency_contact_phone || "N/A",
    });
    console.log("tenantInfo");
  };

  // Add state for the new house number
  // const [selectedHouseNumber, setSelectedHouseNumber] = useState('');
  const [selectedNewHouseNumber, setSelectedNewHouseNumber] = useState(""); // For new house number

  // This function will handle selecting the new house number for the tenant
  const handleNewHouseSelection = (event) => {
    setSelectedNewHouseNumber(event.target.value);
  };

  // This function will handle moving the tenant to the new house
  const handleMoveTenant = () => {
    // Logic to move tenant goes here
    // For example, you could make an API call to update the tenant's house in the database

    console.log(`Moving tenant to house number: ${selectedNewHouseNumber}`);

    // Example API call (pseudo-code)
    // api.moveTenant({
    //   tenantId: tenantInfo.tenantId,
    //   newHouseNumber: selectedNewHouseNumber
    // }).then(response => {
    //   // Handle success or failure of the move operation
    // });

    // After moving tenant, clear the selection or close modal, etc.
    setSelectedNewHouseNumber("");
    setSelectedHouseNumber("");
  };

  //handle create new tenant

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    nationalId: "",
    phoneNumber: "",
    paidDeposit: "",
    unpaidDeposit: "",
    arrears: "",
    unpaidWaterBills: "",
    houseNumber: "",
  });

  const handleInputChangeCreateTenant = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = () => {
    // Validation: Check if all fields are filled
    const isFormComplete = Object.values(formData).every(
      (field) => field.trim() !== ""
    );

    if (!isFormComplete) {
      alert("Please fill out all fields before submitting.");
      return;
    }

    const selectedHouse = houseList.find(
      (house) => house.house_number === formData.houseNumber
    );

    dispatch(
      tenant({
        newTenant: {
          tenant_name: formData.fullName,
          tenant_email: formData.email,
          tenant_phone_number: formData.phoneNumber,
          tenant_id_number: formData.nationalId,
          unpaid_deposit: formData.unpaidDeposit,
          arrears: formData.arrears,
          unpaid_water_bill: formData.unpaidWaterBills,
        },
        token,
        house: selectedHouse.house_id,
        property: property_id,
      })
    ).then((res) => {
      console.log("tenant created", res);
      closeModal();
    });

    // If form is complete, handle form submission (e.g., send to an API)
    console.log(formData);
  };

  //handle edit tenant
  const handleEditTenant = () => {
    // // Validation: Check if all fields are filled
    // const isFormComplete = Object.values(tenantInfo).every(
    //   (field) => field.trim() !== ""
    // );

    // if (!isFormComplete) {
    //   alert("Please fill out all fields before submitting.");
    //   return;
    // }

    let selectedHouse = null;
    if (selectedHouseNumber != "") {
      selectedHouse = houseList.find(
        (house) => house.house_number === selectedHouseNumber
      );
    } else {
      console.log(tenantData.house_id);
    }

    dispatch(
      updateTenant({
        tenant: {
          tenant_name: tenantInfo.firstName + " " + tenantInfo.lastName,
          tenant_email: tenantInfo.email,
          tenant_phone_number: tenantInfo.phoneNumber,
          tenant_id_number: tenantInfo.nationalId,
          emergency_contact_phone: tenantInfo.emergencyContact,
          tenant_id: tenantData.id,
          house: selectedHouse?.house_id || tenantData.house_id,
        },
        token,
        property_id,
      })
    ).then((res) => {
      if (res.payload.statusCode === 100) {
        console.log("tenant updated");

        dispatch(fetchTenants({ property_id, token }));
        closeModal();
      } else {
        alert("An error occurred while updating tenant");
      }
    });
  };

  //handle delete tenant
  const handleDeleteTenant = () => {
    let selectedHouse = null;
    if (selectedHouseNumber != "") {
      selectedHouse = houseList.find(
        (house) => house.house_number === selectedHouseNumber
      );

      console.log("selected", selectedHouse);
    } else {
      console.log(tenantData.house_id);
    }

    dispatch(
      deleteTenant({
        tenant_id: selectedHouse?.tenant?.tenant_id,
        house_id: selectedHouse?.house_id,
        property_id,
        token,
      })
    ).then((res) => { 
      console.log("tenant deleted", res);
    });
  };

  // Modal content based on the fieldToShow
  const renderModalContent = () => {
    if (fieldToShow === "create new tenant") {
      return (
        <>
          {vacantHouses?.length > 0 ? (
            <>
              <div>
                <input
                  style={styles.input}
                  type="text"
                  placeholder="Full Names"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleInputChangeCreateTenant}
                />
                <input
                  style={styles.input}
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChangeCreateTenant}
                />
                <input
                  style={styles.input}
                  type="number"
                  placeholder="National ID"
                  name="nationalId"
                  value={formData.nationalId}
                  onChange={handleInputChangeCreateTenant}
                />
                <input
                  style={styles.input}
                  type="number"
                  placeholder="Phone Number"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleInputChangeCreateTenant}
                />
                <input
                  style={styles.input}
                  type="number"
                  placeholder="Paid Deposit"
                  name="paidDeposit"
                  value={formData.paidDeposit}
                  onChange={handleInputChangeCreateTenant}
                />
                <input
                  style={styles.input}
                  type="number"
                  placeholder="Unpaid Deposit"
                  name="unpaidDeposit"
                  value={formData.unpaidDeposit}
                  onChange={handleInputChangeCreateTenant}
                />
                <input
                  style={styles.input}
                  type="number"
                  placeholder="Arrears"
                  name="arrears"
                  value={formData.arrears}
                  onChange={handleInputChangeCreateTenant}
                />
                <input
                  style={styles.input}
                  type="number"
                  placeholder="Unpaid Water Bills"
                  name="unpaidWaterBills"
                  value={formData.unpaidWaterBills}
                  onChange={handleInputChangeCreateTenant}
                />
                <select
                  style={styles.input}
                  name="houseNumber"
                  value={formData.houseNumber}
                  onChange={handleInputChangeCreateTenant}
                >
                  <option value="">Select House Number</option>
                  {vacantHouses.length > 0 ? (
                    vacantHouses.map((house, index) => (
                      <option key={index} value={house}>
                        {house}
                      </option>
                    ))
                  ) : (
                    <option disabled>No vacant houses</option>
                  )}
                </select>
                <button
                  style={styles.button}
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                  onClick={handleSubmit}
                >
                  Create Tenant
                </button>
              </div>
            </>
          ) : (
            <p style={{ textAlign: "center" }}>No vacant houses</p>
          )}
        </>
      );
    }

    if (fieldToShow === "modify tenant") {
      return (
        <>
          {occupiedHouses?.length > 0 ? (
            <>
              <div>
                {Object.keys(tenantData).length === 0 ? (
                  <>
                    <select
                      style={styles.input}
                      name="houseNumber"
                      onChange={handleHouseSelection}
                    >
                      <option value="">Select House Number</option>
                      {houseNumbers.map((house, index) => (
                        <option key={index} value={house}>
                          {house}
                        </option>
                      ))}
                    </select>
                  </>
                ) : (
                  <div>
                    <div style={styles.sideBySide}>
                      <input
                        type="text"
                        name="firstName"
                        placeholder="First Name"
                        value={tenantInfo.firstName}
                        style={{ ...styles.input, marginBottom: "10px" }}
                        onChange={handleInputChange}
                      />
                      <input
                        type="text"
                        name="lastName"
                        placeholder="Last Name"
                        value={tenantInfo.lastName}
                        style={{ ...styles.input, marginBottom: "10px" }}
                        onChange={handleInputChange}
                      />
                    </div>
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      style={styles.input}
                      value={tenantInfo.email}
                      onChange={handleInputChange}
                    />
                    <input
                      type="tel"
                      name="phoneNumber"
                      placeholder="Phone Number"
                      style={styles.input}
                      value={tenantInfo.phoneNumber}
                      onChange={handleInputChange}
                    />
                    <input
                      type="tel"
                      name="emergencyContact"
                      placeholder="Emergency Contact"
                      value={tenantInfo.emergencyContact}
                      style={styles.input}
                      onChange={handleInputChange}
                    />
                    <input
                      type="number"
                      name="nationalId"
                      placeholder="National ID Number"
                      value={tenantInfo.nationalId}
                      style={styles.input}
                      onChange={handleInputChange}
                    />
                    <button
                      style={styles.button}
                      onMouseEnter={() => setHover(true)}
                      onMouseLeave={() => setHover(false)}
                      onClick={handleEditTenant}
                    >
                      Save Changes
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <p style={{ textAlign: "center" }}>No Tenants</p>
          )}
        </>
      );
    }

    if (fieldToShow === "delete tenant") {
      if (Object.keys(tenantData).length === 0) {
        // tenantData is an empty object
        return (
          <div>
            <p style={{ textAlign: "center" }}>
              Select house number to delete tenant
            </p>
            <select
              style={styles.input}
              name="houseNumber"
              onChange={handleHouseSelection}
            >
              <option value="">Select House Number</option>
              {occupiedHouses.map((house, index) => (
                <option key={index} value={house}>
                  {house}
                </option>
              ))}
            </select>
          </div>
        );
      } else {
        // tenantData contains data
        return (
          <div>
            <p>
              Are you sure you want to delete tenant{" "}
              <span style={{ color: "#b39359" }}> {tenantData.name}</span> of
              tenant ID{" "}
              <span style={{ color: "#b39359" }}> {tenantData.id}</span> ?
            </p>
            <div style={styles.sideBySide}>
              <button
                style={styles.confirm}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => {
                  handleDeleteTenant();
                }}
              >
                Confirm
              </button>
              <button style={styles.cancel} onClick={closeModal}>
                Cancel
              </button>
            </div>
          </div>
        );
      }
    }

    if (fieldToShow === "move tenant") {
      return (
        <div>
          {!selectedHouseNumber && (
            <>
              <select
                style={styles.input}
                name="houseNumber"
                onChange={handleHouseSelection}
              >
                <option value="">Select House Number</option>
                {occupiedHouses.map((house, index) => (
                  <option key={index} value={house}>
                    {house}
                  </option>
                ))}
              </select>
            </>
          )}

          {selectedHouseNumber && tenantInfo && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <h3 style={{ textAlign: "center" }}>Tenant Information</h3>
              <div style={{ width: "76%" }}>
                <div style={styles.titleAndDetailsContainer}>
                  <div style={styles.smallTitle}>Name:</div>
                  <div style={styles.details}>
                    {tenantInfo.firstName} {tenantInfo.lastName}
                  </div>
                </div>
                <div style={styles.titleAndDetailsContainer}>
                  <div style={styles.smallTitle}>Current House Number:</div>
                  <div style={styles.details}>{selectedHouseNumber}</div>
                </div>
                <div style={styles.titleAndDetailsContainer}>
                  <div style={styles.smallTitle}>Tenant ID:</div>
                  <div style={styles.details}>{tenantInfo.id}</div>
                </div>
              </div>

              <h4>Select New House Number to Move Tenant</h4>
              <select
                style={styles.input}
                name="newHouseNumber"
                onChange={handleNewHouseSelection}
              >
                <option value="">Select New House Number</option>
                {vacantHouses.map((house, index) => (
                  <option key={index} value={house}>
                    {house}
                  </option>
                ))}
              </select>

              {selectedNewHouseNumber && (
                <button
                  style={styles.button}
                  type="button"
                  onClick={handleMoveTenant}
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                >
                  Move Tenant
                </button>
              )}
            </div>
          )}
        </div>
      );
    }
  };

  // if (!isSmallScreen) return null; // Return nothing if it's not a small/medium screen

  //styling
  //hover functionality for button
  const [hover, setHover] = useState(false);
  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.7)", // Dark translucent overlay
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    },
    modalContent: {
      backgroundColor: "white",
      padding: "40px 20px 20px 20px",

      borderRadius: "8px",
      width: "90%", // Adapt to smaller screens
      maxWidth: "500px",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
      position: "relative",
      zIndex: 10000, // Ensure it's above the overlay
      animation: "fadeIn 0.3s ease",
    },
    closeBtn: {
      position: "absolute",
      top: "10px",
      right: "15px",
      fontSize: "24px",
      background: "none",
      border: "none",
      cursor: "pointer",
    },
    input: {
      width: "100%",
      padding: "10px",
      marginBottom: "10px",
      borderRadius: "5px",
      border: "1px solid #ccc",
    },
    button: {
      width: "100%",
      padding: "10px",
      borderRadius: "5px",
      border: "none",
      backgroundColor: hover ? "#B39359" : "#192A3A",
      color: "white",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    sideBySide: {
      display: "flex",
      flexDirection: "row",
      gap: "10px",
      alignItems: "center",
    },
    confirm: {
      padding: "10px",
      borderRadius: "5px",
      border: "none",
      backgroundColor: "#192A3A",
      color: "white",
      cursor: "pointer",
      width: "50%",
      transition: "background-color 0.3s ease",
    },
    cancel: {
      padding: "10px",
      borderRadius: "5px",
      border: "none",
      backgroundColor: "#B39359",
      color: "white",
      cursor: "pointer",
      width: "50%",
      transition: "background-color 0.3s ease",
    },
    titleAndDetailsContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",

      marginBottom: "5px",
    },
    smallTitle: {
      fontSize: "16px",
      fontFamily: "Poppins, sans-serif",
      fontWeight: 200,
    },
    details: {
      fontFamily: "Poppins, sans-serif",
      fontWeight: 400,
      fontSize: "16px",
    },
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modalContent} ref={modalRef}>
        <button style={styles.closeBtn} onClick={closeModal}>
          &times;
        </button>
        {renderModalContent()}
      </div>
    </div>
  );
};

export default TenantModificationModal;
